import React, { createContext, useContext, useState, useCallback } from "react";

const AppContext = createContext(null);

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
};

export const AppProvider = ({ children }) => {
  const now = new Date();
  const demo = [
    { id: "d1", kidName: "Aarav Sharma",  parentMobile: "9876543210", numberOfKids: 1, duration: 60, pricePerHour: 500, entryTime: new Date(now - 20*60000), exitTime: new Date(now + 40*60000), paymentMode: "cash", isActive: true,  totalAmount: 500  },
    { id: "d2", kidName: "Priya Patel",   parentMobile: "9123456789", numberOfKids: 2, duration: 60, pricePerHour: 500, entryTime: new Date(now - 50*60000), exitTime: new Date(now + 10*60000), paymentMode: "upi",  isActive: true,  totalAmount: 1000 },
    { id: "d3", kidName: "Rohan Gupta",   parentMobile: "9988776655", numberOfKids: 1, duration: 60, pricePerHour: 500, entryTime: new Date(now - 75*60000), exitTime: new Date(now - 15*60000), paymentMode: "cash", isActive: true,  totalAmount: 500  },
    { id: "d4", kidName: "Ananya Singh",  parentMobile: "9112233445", numberOfKids: 1, duration: 60, pricePerHour: 500, entryTime: new Date(now - 180*60000),exitTime: new Date(now - 120*60000),paymentMode: "upi",  isActive: false, totalAmount: 500  },
    { id: "d5", kidName: "Vivaan Joshi",  parentMobile: "9556677889", numberOfKids: 2, duration: 90, pricePerHour: 500, entryTime: new Date(now - 240*60000),exitTime: new Date(now - 150*60000),paymentMode: "cash", isActive: false, totalAmount: 1500 },
  ];

  const [tickets, setTickets] = useState(demo);
  const [settings, setSettings] = useState({
    defaultDuration: 60,
    defaultPricePerHour: 500,
    greenThreshold: 45,
    orangeThreshold: 60,

    // GST Configuration
    gstPercentage: 0,

    // Printer Configuration
    printerName: "",
    printerType: "LAN",
    printerIP: "",
    printerPort: 9100,
    printerWidth: 80
  });

  const addTicket = (data) => {
    const entryTime = new Date();
    const exitTime = new Date(entryTime.getTime() + data.duration * 60000);
    const totalAmount = (data.duration / 60) * data.pricePerHour * data.numberOfKids;
    const ticket = { ...data, id: crypto.randomUUID(), entryTime, exitTime, isActive: true, totalAmount };
    setTickets(p => [ticket, ...p]);
    return ticket;
  };

  const closeTicket = (id, paymentMode) =>
    setTickets(p => p.map(t => t.id === id ? { ...t, isActive: false, paymentMode } : t));

  const updateSettings = useCallback((partial) => {
    setSettings((p) => ({ ...p, ...partial }));
  }, []);

  return (
    <AppContext.Provider value={{ tickets, settings, addTicket, closeTicket, updateSettings }}>
      {children}
    </AppContext.Provider>
  );
};